import { FC, useEffect, useState } from "react";
import {
  CompanySettingDetails,
  ElectronicBillSetting,
  LoadingBox,
  LoyaltySetting,
  TabView,
  ToastBox,
} from "../../components";
import {
  ActionTypeEnum,
  CompanySettingModel,
  ElectronicBillSettingModel,
  LookupTypeEnum,
  LoyaltySettingModel,
  RequestActionModel,
  ToastModel,
} from "../../models";
import {
  getActiveVouchersSettings,
  getCompanySetting,
  getEgyptInvoiceSettings,
} from "../../serviceBroker/companySettingApiServiceBroker";
import { getLabelName, reValidateLocalStorageCachedData } from "../../utils";
import { ClientFeatureSettingModel } from "../../models/systemConfiugration/clientFeatureSettingModal";
import { getClientFeatures } from "../../serviceBroker/systemSettingApiServiceBroker";

export const CompanySettingPage: FC<{ formId: number }> = ({ formId }) => {
  //#region state
  const [loading, setLoading] = useState(false);
  const [showToastModel, setShowToastModel] = useState(false);
  const [setting, setSetting] = useState<CompanySettingModel | null>();
  const [loyaltySetting, setLoyaltySetting] =
    useState<LoyaltySettingModel | null>();
  const [electronicBillSetting, setElectronicBillSetting] =
    useState<ElectronicBillSettingModel | null>();
  const [clientFeatureSettings, setClientFeatureSettings] =
    useState<ClientFeatureSettingModel | null>(null);
  const [toastModel, setToastModel] = useState<ToastModel>({ show: false });
  //#endregion
  //#region useEffect

  useEffect(() => {
    const fillData = async () => {
      await getSetting();
    };
    fillData().then(() => {});
  }, []);
  //#endregion
  //#region function
  const handleAction = async (request: RequestActionModel) => {
    switch (request.action) {
      case ActionTypeEnum.CloseModelPopup:
        setShowToastModel(false);
        break;
      case ActionTypeEnum.CompanySettingDetails:
        setShowToastModel(true);
        await getSetting();
        break;
    }
  };
  const getSetting = async () => {
    setLoading(true);
    const settingDetails = await getCompanySetting();
    await reValidateLocalStorageCachedData(
      LookupTypeEnum.CompanySettingCacheKey
    );
    setSetting(settingDetails);
    const loyaltySettings = await getActiveVouchersSettings();
    setLoyaltySetting(loyaltySettings);
    const electronicBillSetting = await getEgyptInvoiceSettings();
    setElectronicBillSetting(electronicBillSetting);
    const clientFeatureSettings = await getClientFeatures();
    setClientFeatureSettings(clientFeatureSettings);
    setLoading(false);
  };
  //#endregion
  //#region html
  return (
    <>
      {loading && <LoadingBox />}
      {showToastModel && (
        <ToastBox
          isShown={showToastModel}
          header={toastModel.header}
          body={toastModel.body}
          variant={toastModel.variant}
          delayDuration={toastModel.delayDuration}
          onCloseEvent={() => {
            setShowToastModel(false);
          }}
        />
      )}
      {setting && (
        <TabView
          tabs={[
            {
              name: getLabelName("CompanySettingDetails"),
              content: (
                <CompanySettingDetails
                  request={setting}
                  onActionEvent={async (o: RequestActionModel) => {
                    await handleAction(o);
                  }}
                  formId={formId}
                />
              ),
            },
            ...(clientFeatureSettings &&
            clientFeatureSettings?.EnableCustmerPoint
              ? [
                  {
                    name: getLabelName("LoyaltySetting"),
                    content: (
                      <LoyaltySetting
                        request={loyaltySetting}
                        onActionEvent={async (o: RequestActionModel) => {
                          await handleAction(o);
                        }}
                      />
                    ),
                  },
                ]
              : []),
            ...(clientFeatureSettings &&
            clientFeatureSettings?.EnableEgyptIntegrationTax
              ? [
                  {
                    name: getLabelName("Electronic Bill"),
                    content: (
                      <ElectronicBillSetting
                        request={electronicBillSetting}
                        onActionEvent={async (o: RequestActionModel) => {
                          await handleAction(o);
                        }}
                      />
                    ),
                  },
                ]
              : []),
          ]}
        />
      )}
    </>
  );
  //#endregion
};
